import React from "react";

const KurumCard = () => {
  return (
    <div className="">
      <section className="">
        <div className="py-12 bg-white ">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="font-heading mb-4 bg-orange-100 px-4 py-2 rounded-lg md:w-64 md:mx-auto text-xs font-semibold tracking-widest text-black uppercase title-font">
                Neden Bizi Seçmelisiniz?
              </h2>
              <p className="font-heading mt-2 text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl">
                TOPLANTI & ORGANİZASYON YÖNETİMİ (MICE)
              </p>
              <p className="mt-4 max-w-2xl text-lg text-gray-500 lg:mx-auto">
                Kişisel ya da grup olarak aklınızdan geçirdiğiniz her türlü
                organizasyonda biz yanınızdayız. Dünyanın dört bir yanını
                kapsayan lokasyon bilgimiz ve her türden toplantıların yönetimi
                konusundaki deneyimimizle sizinleyiz. Boyutu ve kişi sayısı hiç
                önemli değil. Yurt içi ve yurt dışında katılmak ya da düzenlemek
                istediğiniz aktivitelerinizi planlıyor ve uyguluyoruz.
              </p>
            </div>
            <div className="mt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/483373/free-whiteboard-7.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Ürün Lansmanları
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    Kurumunuzun, yeni ürünlerini tanıttığı lansmanların altından
                    başarılı bir şekilde kalkmak tam bir takım oyununu
                    gerektiriyor. Konunun uzmanı çalışanlarımız, stratejik iş
                    ortağı anlayışıyla, sizlerle birlikte bir ekip oluşturup
                    verdiğiniz bilgiler doğrultusunda hedefe uygun mekan
                    belirleyerek ürünü yansıtacak şekilde hazırlıyorlar. Bu
                    noktadan sonrası süsleme, catering, sanatçı, animasyon gibi
                    başlıkların belirlenmesine kalıyor. Bu başlıklar da konunun
                    içeriğine göre detaylandırıldıktan sonra ürününüzü tanıtmak
                    için tamamen hazırız. Lansman günü Jojo Turizm’le çalışmanın
                    ayrıcalığını yaşayacaksınız!
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/451394/tour-pin-tear.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Bayi Gezileri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Kurumun tüm bileşenlerini bir araya toplayıp koordinasyonu
                    arttırmak zor bir uğraş. Belki de daha önce birbirini hiç
                    görmemiş çok sayıda insanı ortak hedefe yönlendirmek oldukça
                    güç. Üstelik öyle bir toplantı olmalı ki bu, hem tam
                    istendiği gibi bir bağ kurulsun hem de olabildiğince keyifli
                    geçsin. İşte, Jojo Turizm’in farkı burada ortaya çıkıyor.
                    Gezi öncesi süreçte amaçlar doğrultusunda yaratıcı öneriler
                    sunuyor, bütçe ve lokasyona birlikte karar veriyoruz. Daha
                    sonra konuklarımızı, dünyanın en ilginç yerlerini görmeleri
                    için profesyonel ekibimize teslim ediyoruz. Sizlerse turun
                    ne kadar keyifli ve verimli geçtiğini gelişmiş raporlama
                    sistemimizin verilerini incelediğinizde görüyorsunuz.
                    Keyifli tüm kurumsal turlar sayfamızdan, aradığınız bayi
                    gezilerine ulaşabilirsiniz.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/488086/building.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Kongre Katılım Hizmetleri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Sektörünüz ne olursa olsun, hangi alanda faaliyet
                    gösterirseniz gösterin, dünyanın birçok noktasında işinizle
                    ilgili kongre ve fuarlar düzenleniyor. İster siz katılın
                    isterseniz davet ettiğiniz konuklar katılsın, organizasyona
                    dair hiçbir şeyi düşünmenize gerek yok. Bizler bu konuda da
                    yanınızdayız. Her çeşit kongre ve fuara katılımınızla ilgili
                    kayıtlarınızın yapılması, uçak bileti ve vize alımı gibi
                    işlemlerinizi sizin adınıza yürütüyoruz.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/338981/berlin-tower.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Teşvik Gezileri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Çalışanlarınızın performans grafiklerini yükseltmek, kuruma
                    bağlılıklarını ve bilgi seviyelerini arttırmak ve bunu
                    onlara bir ödül şeklinde sunmak… Konu bu olunca, en mantıklı
                    seçim teşvik gezileri. Dünya büyük bir gezegen. Sayısız
                    lokasyonda binlerce konaklama noktası var. Birini seçin ve
                    gezinizin konseptini belirleyin. Kültürel turlar, eğlence,
                    bütçe, profil ve takvim gibi detaylarıysa bize bırakın.
                  </dd>
                </div>
              </dl>
            </div>
            <div className="mt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/132367/stand-hairdryer.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Sahne, Dekor, Stand Tasarımı ve Uygulamaları
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Sahne, dekor, stand tasarımı ve uygulamaları konusunda
                    müşterilerimize güncel çözümler sunmaktayız. Bu
                    hizmetlerimiz, fuarlar, sergiler, konferanslar, toplantılar
                    gibi etkinliklerin başarılı bir şekilde gerçekleşmesini
                    sağlar.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/509196/plane.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Uçak Bileti Hizmetleri
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Yurt içi ve yurt dışı seyahatlerinde en uygun uçak bileti
                    seçeneklerini sunarak, müşterilerimizin bütçelerine en uygun
                    seyahat planlarını yapmalarını sağlıyoruz. Uçak bileti
                    hizmetlerimiz kapsamında, müşterilerimize en uygun fiyatlı
                    ve en hızlı uçuş seçeneklerini sunuyoruz.
                  </dd>
                </div>
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <img src="https://www.svgrepo.com/show/497339/music-circle.svg" />
                    </div>
                    <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-600">
                      Roadshow Yönetimi
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {" "}
                    Roadshowlar, işletmenizin veya ürünlerinizin tanıtımı için
                    düzenlenen mobil etkinliklerdir. Bu etkinlikler,
                    müşterilerinize doğrudan ulaşmanızı sağlar ve işletmenizin
                    tanıtımını daha geniş kitlelere yaymanıza yardımcı olur.
                    Roadshow yönetimi hizmetimiz, etkinliğin tüm yönlerini
                    yönetir ve planlama, organizasyon ve tanıtım işlerini sizin
                    için halleder. Müşterilerimize özelleştirilmiş roadshow
                    planları sunarak, işletmenizin ihtiyaçlarına en uygun
                    stratejileri geliştiririz.
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>
      <>
        {/* Container for demo purpose */}
        <div className="container my-24 mx-auto md:px-6">
          {/* Section: Design Block */}
          <section className="mb-32 m-10">
            {/* Comment */}
            <div className="mb-12 flex flex-wrap md:mb-0">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://images.pexels.com/photos/325193/pexels-photo-325193.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="mb-3 text-2xl font-semibold">Kurumsal Turlar</p>
                <p>
                  Kurumlara özel düzenlediğimiz kurumsal turlar, farklı birçok
                  bölge, alanında uzman kişilerle düzenlenen kurumsal turlar
                  için Jojo Turizm'den destek alabilirsiniz.
                </p>
              </div>
            </div>
            {/* Comment */}
            <div className="mb-12 flex flex-wrap md:mb-0">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://images.pexels.com/photos/1928064/pexels-photo-1928064.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="mb-12 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="mb-2 text-2xl font-semibold">
                  Yerel Hizmetler Yönetimi
                </p>
                <p className="text-xl text-gray-600 mb-2">
                  Incoming ve Yurtiçi Rezervasyon Hizmetleri
                </p>
                <p>
                  Türkiye’nin önemli turizm merkezlerine günübirlik ya da değil,
                  kültür gezileri düzenliyoruz. Bunlara katılmak ya da iş
                  toplantılarınızdan boş zaman aktivitelerinize dek her anınızı
                  Ülkemizin eşsiz güzellikleriyle geçirmek sizin seçiminiz.
                  Üstelik işe dair her türlü birlikteliğinizi geçirebilmeniz
                  için özel olarak hazırladığımız tekne gezilerimiz de
                  seçenekler arasında. Mavi yolculuklar, hatta İstanbul, Boğaz
                  ve adalar gezileri sizi bekliyor!
                </p>
                <p className="text-xl text-gray-600 mb-2">
                  Jojo Transfer Hizmetleri
                </p>
                <p>
                  Dünyanın her yerinde istediğiniz saatte istediğiniz yerden
                  transferinizi gerçekleştirebiliriz. Bizi arayın, sizi veya
                  misafirlerinizi karşılayalım, havalimanından alalım ve otele
                  bırakalım. Binek, lüks, minibüs veya otobüs her türlü konforlu
                  araçla isterseniz yolda küçük bir panoramik tur da yapalım.
                </p>
              </div>
            </div>
            {/* Comment */}
            <div className="flex flex-wrap">
              <div className="w-full md:w-2/12 shrink-0 grow-0 basis-auto">
                <img
                  src="https://images.pexels.com/photos/20235440/pexels-photo-20235440/free-photo-of-siyah-ve-beyaz-kent-sehir-fransa.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
                  alt="Avatar"
                />
              </div>
              <div className="w-full md:w-10/12 shrink-0 grow-0 basis-auto md:pl-6">
                <p className="mb-2 text-2xl font-semibold">
                  Diğer Kurumsal Hizmetler
                </p>
                <p className="text-xl text-gray-600 mb-2">
                  Rezervasyon Hizmetleri
                </p>
                <p className="mb-1">
                  İstanbul’daki iki noktaya ek olarak Ankara ve Adana’daki
                  ofislerimizle sizleri istediğiniz yere ulaştırıyoruz.
                  Yolculuğa başlamadan önce, 150.000 otel seçeneği arasından
                  istediğinizi seçip yer ayırtabiliyor; seçkin firmalardan araba
                  kiralayabiliyorsunuz. Tüm bunların en kolay yolu Jojo Turizm.
                </p>
                <p className="text-xl text-gray-600 mb-2">Vize Hizmetleri</p>
                <p className="mb-1">
                  Akredite olduğumuz tüm elçilik ve konsolosluklarda mümkün ise
                  işlemleri sizin adınıza yürütüyor veya evrakınızı
                  hazırlıyoruz. Bunu yaparken paylaştığınız bilgilerin gizliliği
                  ve güvenliğine dikkat ediyor, tüm işlemleri kamera görüntüleri
                  dahil kayıt altına alıyoruz. Jojo Turizm’deki departmanlardan
                  biri de Vize Departmanı. Bu bölümde çalışan arkadaşlarımız,
                  bütün konsolosluklarda kurumumuzun güvenilirliğini sağlayarak
                  ulaştılar uzmanlıklarına.
                </p>
                <p className="text-xl text-gray-600 mb-2">24 Saat Hizmet</p>
                <p>
                  Yanınızda olmaya söz verdiğimize göre bunu aralıksız olarak
                  yapmalıyız. Yurt içinde size vereceğimiz özel cep telefonu
                  numaralarını tuşlayacaksınız ve herhangi bir saatte
                  gereksinimlerinize karşılık alacaksınız.
                </p>
              </div>
            </div>
          </section>
          {/* Section: Design Block */}
        </div>
        {/* Container for demo purpose */}
      </>
    </div>
  );
};

export default KurumCard;
